import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

const { app } = window;

function addFmSearch(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("fmSearch", {
		vuwType: "searchForm",
		
		selector() {
			return $("<form/>").addClass("fm fm-search").attr("id", "fm_search")
			.appendTo(this.container.$content);
		},
		
		onSubmit(valObj) {
			const state = { ...valObj };
			const sort = vuwer.getState("sort");
			if(sort) {
				state.sort = sort;
			}
			return vuwer.setState(state);
		},
		
		async refresh() {
			this.$self.empty();
			
			const { config } = app.module;
			
			if(
				!u_.isObject(config.search) ||
				!Object.keys(config.search).length
			) {
				return false;
			}
			
			this.initForm(config);
			
			const dataKey = app.module.getDataKey();
			
			// コールバックの実行
			if( u_.isFunction(app.searchFormInitCallBacks[dataKey]) ) {
				const res = await app.searchFormInitCallBacks[dataKey].call(
					this, this.$self, this
				);
				
				if(res === false) {
					return res;
				}
			}
			if( u_.isFunction(app.searchFormInitCallBacks.always) ) {
				const res = await app.searchFormInitCallBacks.always.call(
					this, this.$self, this
				);
				
				if(res === false) {
					return res;
				}
			}
			
			return true;
		}
	}, function() {
		// appから直接アクセス可能にする
		app.fm.search = this;
	});
}

export default addFmSearch;
